import { useTranslation } from "react-i18next";

const NewOrder = () => {
    const { t } = useTranslation("global");
    return <span
        style={{
            background: "#DB1F35",
            borderRadius: '6px',
            padding: "5px 10px",
            color: 'white',
        }}
    >
        {t("New Order")}
    </span>
}
export default NewOrder;